import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'index',
		component: () => import('../views/index.vue')
	},
	{
		path: '/login',
		name: 'login',
		component: () => import('../views/login.vue')
	},
	{
		path: '/cityIndex',
		name: 'cityIndex',
		component: () => import('../views/cityIndex.vue')
	},
	{
		path: '/provinceIndex',
		name: 'provinceIndex',
		component: () => import('../views/provinceIndex.vue')
	},
	{
		path: '/merchantEchart',
		name: 'merchantEchart',
		component: () => import('../views/merchantEchart.vue')
	},
	{
		path: '/merchantProgress',
		name: 'merchantProgress',
		component: () => import('../views/merchantProgress.vue')
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})
//全局前置守卫
const whiteList = ['/login']; //白名单
router.beforeEach(async (to, from, next) => {
	let accessToken = localStorage.getItem("biDataToken")
	const toPath = to.path;
	if (accessToken) {
		if (toPath === '/login') {
            return next({ path: '/' });
        }else {
            next()
        }
	}else{
		// 没有token
		if (whiteList.indexOf(to.path) !== -1) {
			// 在免登录白名单，直接进入
			next()
		} else {
			next(`/login`)
		}
	}
})

export default router
